import { render, staticRenderFns } from "./IncomingRemittancesManager.vue?vue&type=template&id=341cb750&"
import script from "./IncomingRemittancesManager.vue?vue&type=script&lang=js&"
export * from "./IncomingRemittancesManager.vue?vue&type=script&lang=js&"
import style0 from "./IncomingRemittancesManager.vue?vue&type=style&index=0&id=341cb750&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports